<script setup>
// import dayjs from 'dayjs';
import { useRouter } from 'vue-router';
import { formatDate } from '@/utils/date';
import DateInfo from '@/components/events/DateInfo.vue';
import TimeInfo from '@/components/events/TimeInfo.vue';
import InfoItem from '@/components/events/InfoItem.vue';
import InPersonVirtualEventTemplate from './InPersonVirtualEventTemplate.vue';

const props = defineProps({
  event: Object,
});

const router = useRouter();
const routeOnRegister = () => router.push({
  path: `/waiting-room/${props.event.id}`,
});

</script>
<template>
  <in-person-virtual-event-template :event="event" @registered="routeOnRegister">
    <template v-slot:hero-details>
      <div>{{ formatDate(event?.startDateTime, false)}}</div>
      <div>{{ event?.time }}</div>
      <div v-if="event?.duration">Duration: {{ event?.duration }}</div>
    </template>
    <template v-slot:info-details>
      <date-info
        class="mb-[2rem] hidden tablet:block"
        :startDateTime="event?.startDateTime"
        show-day-of-week
      />
      <time-info
        :time="event?.time"
        :duration="event?.duration" class="mb-8" />
      <info-item v-if="event?.location" label="Location" :value="event?.location" />
    </template>
  </in-person-virtual-event-template>
</template>
